import getCRUDVerbName from './get-crud-verb-name';
import { ACTION_TYPE_BASE } from '../lib/constants';

export default function createCRUDActionType(name, verb) {
  const actionType = [];

  actionType.push(ACTION_TYPE_BASE);

  const CRUDVerbName = getCRUDVerbName(verb);
  if (!CRUDVerbName) throw new Error(`Invalid CRUD operation type: ${verb}`);
  actionType.push(CRUDVerbName);

  return actionType.join('/');
}
